var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "loader" },
    [
      _c("x-progress-circular", {
        staticClass: "compact",
        attrs: { indeterminate: "", size: "150", width: "8" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }